import { Chip, Tooltip } from '@mui/material'
import React from 'react';
import { useIsTab } from "hooks/is-tab.hook";
import { HiOutlineLockOpen } from 'react-icons/hi2';

const OpenAccessChip = () => {
    const isTab = useIsTab();
  return (
        <Tooltip title="100% of this publisher's content is Open Access">
            <Chip
            sx={{
                p: 1,
                height: "24px",
                fontSize: "12px",
                "& .MuiChip-icon": {
                margin: 0,
                },
                "& .MuiChip-label": {
                display: isTab ? "none" : "inline",
                },
            }}
            icon={<HiOutlineLockOpen sx={{height: "22px"}} />}
            label={isTab ? "" : "Open Access"}
            />
        </Tooltip>
        )
}

export default OpenAccessChip